import './App.css';
import {Component} from 'react'
import {LoadScript} from '@react-google-maps/api'
import RightMenu from './Components/RightMenu';
import TopMenu from './Components/TopMenu';
import GM from './Components/GM';
import InfoBox from './Components/InfoBox';
import {getDistanceOnEarth} from "@baggie/math";
import {Container, Row, Col} from 'react-bootstrap'

import kalpi1 from './data/model1/kalpi_detail.json';
import clusters1 from './data/model1/cluster_details.json';
import all_coords1 from './data/model1/all_coords_dict.json';
import kalpi2 from './data/model2/kalpi_detail.json';
import clusters2 from './data/model2/cluster_details.json';
import all_coords2 from './data/model2/all_coords_dict.json';

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            model: 2,
            markers: [],
            clustersToRender: [],
            kalpies: kalpi1,
            all_coords: all_coords1,
            all_clusters: clusters1,
            currentShownCluster: 0,
            city: '',
            showInfo: false,
            showPolicy: {"polygons": true, "numbers": false, "kalpies": false},
            center: {lat: 31.770523266798048, lng: 35.21522033578535},
            bounds: {"north": 32, "south": 29, "west": 33, "east": 34},
            cities_en2he: {
                "Tel Aviv-Yafo, Israel": "תל אביב-יפו",
                "Jerusalem, Israel": "ירושלים",
                "Haifa, Israel": "חיפה",
                "Ramat Gan, Israel": "רמת-גן",
                "Petah Tikva, Israel": "פתח-תקווה",
                "Rishon LeZion, Israel": "ראשון-לציון",
                "Netanya, Israel": "נתניה",
                "Be'er Sheva, Israel": "באר-שבע",
                "Bnei Brak, Israel": "בני-ברק",
                "Bat Yam, Israel": "בת-ים",
                "Holon, Israel": "חולון",
                "Ashdod, Israel": "אשדוד",
                "Herzliya, Israel": "הרצליה",
                "Kefar Sava, Israel": "כפר-סבא",
                "Ra'anana, Israel": "רעננה",
                "Nazareth, Israel": "נצרת",
                "Hadera, Israel": "חדרה",
                "Ashkelon, Israel": "אשקלון",
                "Rehovot, Israel": "רחובות",
                "Bet Shemesh, Israel": "בית-שמש",
                "Modi'in-Maccabim-Re'ut, Israel": "מודיעין-מכבים-רעות",
                "Lod, Israel": "לוד",
                "Ramla, Israel": "רמלה"
            }
        }
    }

    seeAll = () => {
        this.setState({
            city: '',
            markers: this.state.kalpies,
            clustersToRender: this.state.all_clusters,
            currentShownCluster: -1,
            showPolicy: this.state.showPolicy,
            showInfo: true
        });
    }

    restartMap = () => {
        this.setState({
            city: '',
            markers: [],
            clustersToRender: [],
            currentShownCluster: 0,
            showInfo: false,
            center: {lat: 31.770523266798048, lng: 35.21522033578535},
            bounds: {"north": 32, "south": 29, "west": 33, "east": 34},
        })
    }

    renderCluster(num) {
        this.setState({markers: [], clustersToRender: []})
        var closest_cluster = this.state.all_clusters.find(clusters => clusters["cluster_num"] === num)
        this.setState({
            city: '',
            markers: this.state.kalpies.filter(kalpi => kalpi["cluster_num"] === num),
            clustersToRender: [closest_cluster],
            currentShownCluster: num,
            showInfo: true,
            center: closest_cluster["fake_centroid"],
            bounds: closest_cluster["bounds"]
        });
    }

    showCluster = (input) => {
        var min_dist = 10000, min_pt = null;
        this.state.kalpies.forEach(function (elem, _) {
            var dist = getDistanceOnEarth(input, elem);
            if (dist < min_dist) {
                min_dist = dist;
                min_pt = elem;
            }
        });
        this.renderCluster(min_pt["cluster_num"]);
    }

    calcBounds = (city_clusters) => {
        var _north = 0, _south = 100, _east = 0, _west = 100;
        for (const cluster of city_clusters) {
            _north = Math.max(_north, cluster["bounds"]["north"]);
            _south = Math.min(_south, cluster["bounds"]["south"]);
            _east = Math.max(_east, cluster["bounds"]["east"]);
            _west = Math.min(_west, cluster["bounds"]["west"]);
        }
        return {"north": _north, "south": _south, "west": _west, "east": _east}
    }

    showCity = (city_str) => {
        var city_clusters = this.state.all_clusters.filter(clusters => clusters["cities"].includes(city_str));
        var mandate_numbers = [];
        for (const cluster of city_clusters) {
            mandate_numbers.push(cluster["cluster_num"])
        }
        const bounds = this.calcBounds(city_clusters);
        this.setState({
            city: city_str,
            markers: this.state.kalpies.filter(kalpi => mandate_numbers.includes(kalpi["cluster_num"])),
            clustersToRender: city_clusters,
            currentShownCluster: -2,
            showInfo: true,
            center: {"lng": (bounds["north"] + bounds["south"]) / 2, "lat": (bounds["west"] + bounds["east"]) / 2},
            bounds: bounds
        });
    }

    updateModel = (val) => {
        this.setState({
            markers: [], clustersToRender: [],
            model: val,
            kalpies: val === 2 ? kalpi1 : kalpi2,
            all_clusters: val === 2 ? clusters1 : clusters2,
            all_coords: val === 2 ? all_coords1 : all_coords2,
        }, () => {
            if (this.state.currentShownCluster === -1) {
                this.seeAll();
            } else if (this.state.currentShownCluster === 0) {
                this.restartMap();
            } else if (this.state.currentShownCluster > 0) {
                this.renderCluster(this.state.currentShownCluster)
            } else if (this.state.currentShownCluster === -2) {
                this.showCity(this.state.city);
            }
        });
    }

    updateShow = (element) => {
        this.setState({
            showPolicy: {
                ...this.state.showPolicy,
                element: !this.state.showPolicy[element]
            }
        })
    }

    getTitle = () => {
        if (this.state.clustersToRender.length === 1 || this.state.clustersToRender.length === 0 || this.state.cities_en2he[this.state.city] === '') {
            return "";
        }
        if (this.state.clustersToRender.length === 120) {
            return "חלוקת מדינת ישראל ל-120 מחוזות:\n";
        }
        if (this.state.cities_en2he[this.state.city] !== '') {
            return "חלוקת העיר " + this.state.cities_en2he[this.state.city] + " ל-" + this.state.clustersToRender.length + " מחוזות:\n";
        }
    }

    render() {
        return (
            <LoadScript
                googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            >
                <div style={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <Container fluid
                               className='fill-space'>
                        <Row>
                            <TopMenu/>
                        </Row>
                        <Row className='ContentRow'>
                            <Col xs={12} sm={12} md={4} lg={4} xl={4} className='MenuCol'>
                                <Row>
                                    <RightMenu
                                        onClickUpdateModel={this.updateModel}
                                        model={this.state.model}
                                        appShowPolicy={this.state.showPolicy}
                                        onClickUpdateShow={this.updateShow}
                                        onClickSeeAll={this.seeAll}
                                        onClickRestartMap={this.restartMap}
                                        onClickShowCity={this.showCity}
                                        onClickShowCluster={this.showCluster}/>
                                </Row>
                                <Row className='titleRow'>
                                    {this.state.showInfo && <h5 className="title">{this.getTitle()}</h5>}
                                </Row>
                                <Row className='limitedRow'>
                                    <InfoBox
                                        clustersToShow={this.state.clustersToRender}
                                        kalpiesToShow={this.state.markers}
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={8} xl={8} className="MapCol">
                                <GM
                                    key={this.state.markers}
                                    showPolicy={this.state.showPolicy}
                                    markersToRender={this.state.markers}
                                    clustersToRender={this.state.clustersToRender}
                                    bounds={this.state.bounds}
                                    center={this.state.center}/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </LoadScript>
        );
    }
}

export default App;